<template>
  <div>
    <div class="loading-overlay" v-if="isLoading">
      <div class="spinner-border text-danger" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <bs-page-title
      :titleLabel="fromParentTitle"
      :btnLabel="''"
      :btnClass="'btn-primary'"
      :btnToLink="false"
      :routerSw="true"
    ></bs-page-title>
    <bs-msg-alert :alertClass="alertClass">{{
      this.alertMessage
    }}</bs-msg-alert>
    <h5>直接会員照会</h5>
    <div class="w100 mb-4 pb-3 border-bottom">
      <div>
        <div class="row mb-2">
          <div class="col-2">
            <p class="text-center py-1 fs-5">ライセンスNo</p>
          </div>
          <div class="col-5 mb-2">
            <div class="input-group">
              <input
                type="text"
                id="MainRecordsNo"
                v-model="search_license_no"
                class="form-control"
              />
              <button
                @click="search_member_license_no()"
                type="button"
                class="btn btn-light btn-outline-secondary"
              >
                ライセンスNoから検索
              </button>
            </div>
          </div>
          <div class="col-3 mb-2">
            <input
              type="text"
              id="MainRecordsNo"
              v-model="search_member_obj.name_label"
              class="form-control"
              placeholder="会員名"
              disabled="true"
            />
          </div>
          <div
            class="col-2 mb-2"
            v-if="
              typeof search_member_obj === 'object' &&
              typeof search_member_obj.id === 'string' &&
              search_member_obj.id > 0
            "
          >
            <bs-button
              :btnWrapClass="'d-grid'"
              :btnClass="'btn-light btn-outline-secondary'"
              @to_click_event="handleClick(search_member_obj.id)"
              >照会</bs-button
            >&nbsp;
          </div>
          <div
            class="col-2 mb-2"
            v-else-if="
              typeof search_member_obj === 'object' &&
              typeof search_member_obj.id === 'undefined'
            "
          >
            --
          </div>
        </div>
        <!-- <div class="row mb-2">
                    <div class="col-2">
                        <p class="text-center py-1 fs-5">ライセンスNo</p>
                    </div>
                    <div class="col-5 mb-2">
                        <div class="input-group">
                            <input type="text" id="MainRecordsNo" v-model="search_license_no" class="form-control " @change="search_member_license_no()">
                            <button @click="search_member_license_no()" type="button" class="btn btn-light btn-outline-secondary">ライセンスNoから検索</button>
                        </div>
                    </div>
                </div> -->
      </div>
    </div>
    <h5>検索一覧からの照会</h5>
    <div class="w100 mb-5">
      <div>
        <div class="row mb-2 d-none">
          <div class="col-2">
            <p class="text-center py-1 fs-5">ライセンスNo</p>
          </div>
          <div class="col-5 mb-2">
            <div class="input-group">
              <input
                type="text"
                id="MainRecordsNo"
                v-model="search_license_no"
                class="form-control"
                @change="search_member_license_no()"
              />
              <button
                @click="search_member_license_no()"
                type="button"
                class="btn btn-light btn-outline-secondary"
              >
                ライセンスNoから検索
              </button>
            </div>
          </div>
          <div class="col-3 mb-2">
            <input
              type="text"
              id="MainRecordsNo"
              v-model="search_member_obj.name_label"
              class="form-control"
              placeholder="会員名"
              disabled="true"
            />
          </div>
          <div
            class="col-2 mb-2"
            v-if="
              typeof search_member_obj === 'object' &&
              typeof search_member_obj.id === 'string' &&
              search_member_obj.id > 0
            "
          >
            <bs-button
              :btnWrapClass="'d-grid'"
              :btnClass="'btn-light btn-outline-secondary'"
              @to_click_event="handleClick(search_member_obj.id)"
              >照会</bs-button
            >&nbsp;
          </div>
          <div
            class="col-2 mb-2"
            v-else-if="
              typeof search_member_obj === 'object' &&
              typeof search_member_obj.id === 'undefined'
            "
          >
            --
          </div>
        </div>
        <div class="row mb-1">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">最終年度</p>
          </div>
          <div class="col-2 mb-2">
            <div class="input-group">
              <bs-select
                :options="year_list"
                v-model="sprm.last_sports_year"
                :null-option="true"
                id="MainClinicId"
                :classParam="'form-select'"
              ></bs-select>
              <!-- <span class="input-group-text">以降</span> -->
            </div>
          </div>
          <div class="col-1 mb-2" v-if="false">
            <p class="text-center py-1 fs-5">年度</p>
          </div>
          <div class="col-2 mb-2" v-if="false">
            <div class="input-group">
              <bs-select
                :options="year_list"
                v-model="sprm.sports_year"
                :null-option="true"
                id="MainClinicId"
                :classParam="'form-select'"
              ></bs-select>
              <!-- <span class="input-group-text">以降</span> -->
            </div>
          </div>
          <div class="col-1 mb-2" v-if="false">
            <p class="text-center py-1 fs-5">範囲</p>
          </div>
          <div class="col-4 mb-2" v-if="false">
            <div class="input-group">
              <bs-select
                :options="year_list"
                v-model="sprm.last_sports_year_higher"
                :null-option="true"
                id="MainClinicId"
                :classParam="'form-select'"
              ></bs-select>
              <span class="input-group-text">〜</span>
              <bs-select
                :options="year_list"
                v-model="sprm.last_sports_year_lower"
                :null-option="true"
                id="MainClinicId"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">氏名/カナ</p>
          </div>
          <div class="col-5 mb-2">
            <div class="input-group">
              <span class="input-group-text">姓</span>
              <input
                type="text"
                v-model="sprm.like_name_1"
                class="form-control"
                placeholder="姓"
              />
              <span class="input-group-text">名</span>
              <input
                type="text"
                v-model="sprm.like_name_2"
                class="form-control"
                placeholder="名"
              />
            </div>
          </div>
          <div class="col-5 mb-2">
            <div class="input-group">
              <span class="input-group-text">セイ</span>
              <input
                type="text"
                v-model="sprm.like_yomi_1"
                class="form-control"
                placeholder="セイ"
              />
              <span class="input-group-text">メイ</span>
              <input
                type="text"
                v-model="sprm.like_yomi_2"
                class="form-control"
                placeholder="メイ"
              />
            </div>
            <!-- <input type="text" id="MainRecordsNo" v-model="sprm.like_yomi" class="form-control " placeholder="会員名(カナ)"> -->
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">生年月日</p>
          </div>
          <div class="col-6 mb-2">
            <div class="input-group">
              <bs-select
                :options="birth_date_year_list"
                v-model="sprm.birth_date_year"
                :null-option="false"
                :classParam="'form-select'"
              ></bs-select>
              <span class="input-group-text">年</span>
              <bs-select
                :options="birth_date_month_list"
                v-model="sprm.birth_date_month"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
              <span class="input-group-text">月</span>
              <bs-select
                :options="
                  birth_date_day_list(
                    sprm.birth_date_year,
                    sprm.birth_date_month
                  )
                "
                v-model="sprm.birth_date_day"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
              <span class="input-group-text">日</span>
            </div>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <input
                type="text"
                :value="get_wareki(sprm.birth_date)"
                class="form-control-plaintext"
                placeholder=""
                readonly="true"
              />
            </div>
          </div>
        </div>
        <h5>ライセンス</h5>
        <div class="row mb-2">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">年度</p>
          </div>
          <div class="col-3 mb-2">
            <div class="input-group">
              <bs-select
                :options="year_list"
                v-model="sprm.sp_license_year"
                :null-option="true"
                id="MainClinicId"
                :classParam="'form-select'"
              ></bs-select>
            </div>
          </div>
        </div>
        <!-- {{ attach_license_event_cd }} -->
        <div class="row mb-1">
          <!-- ライセンスクラス別のセクション -->
          <!-- [1,4,2,3]の順番で: 競技ライセンス、PIT、競技役員、競技講師 -->
          <div
            class="col mb-2"
            v-for="license_class in [1, 4, 2, 3]"
            :key="license_class"
          >
            <!-- ライセンスクラスのヘッダーラベル -->
            <label class="mb-1 badge bg-secondary" v-if="license_class == 1"
              >競技ライセンス</label
            >
            <label class="mb-1 badge bg-secondary" v-if="license_class == 2"
              >競技役員</label
            >
            <label class="mb-1 badge bg-secondary" v-if="license_class == 3"
              >競技講師</label
            >
            <label class="mb-1 badge bg-secondary" v-if="license_class == 4"
              >PIT</label
            >
            <!-- {{ open_event_cd }} -->
            <!-- {{ license_cd_filter(1, 1) }} -->
            <!-- スクロール可能なライセンスコンテナ -->
            <div
              class="w-100 border py-1 px-2"
              style="height: 300px; overflow-y: scroll"
              v-if="typeof license_event_cd_filter(license_class) === 'object'"
            >
              <!-- イベントカテゴリーのループ -->
              <div
                v-for="lc_event in license_event_cd_filter(license_class)"
                :key="lc_event"
                class="mb-1 pb-1 container"
              >
                <!-- イベントカテゴリーのヘッダー行 -->
                <div
                  :class="
                    'row py-1 px-2 rounded-1 mb-2 border ' +
                    attach_event_class_label(lc_event.id, license_class)
                  "
                >
                  <!-- カテゴリー選択部分 -->
                  <div
                    v-if="license_class != 4"
                    class="col-9"
                    @click="attach_event(lc_event.id, license_class)"
                  >
                    <!-- チェックボックスアイコン -->
                    <i
                      :class="
                        attach_event_class_checkbox(lc_event.id, license_class)
                      "
                    ></i
                    >&nbsp; {{ lc_event.label }}
                  </div>
                  <div
                    v-else-if="license_class == 4"
                    class="col-9"
                    @click="
                      attach_license(lc_event.id, lc_event.id, license_class)
                    "
                  >
                    <!-- チェックボックスアイコン -->
                    <i
                      :class="
                        attach_license_class_checkbox(lc_event.id) + ' me-1'
                      "
                    ></i
                    >&nbsp; {{ lc_event.label }}
                  </div>

                  <!-- 展開/折りたたみボタン -->
                  <div
                    v-if="license_class != 4"
                    class="col-3 text-end"
                    @click="attach_open_event(lc_event.id, license_class)"
                  >
                    <i
                      :class="
                        attach_event_class_caret(lc_event.id, license_class)
                      "
                    ></i>
                  </div>
                </div>

                <!-- 個別ライセンス選択エリア（カテゴリーが展開時のみ表示） -->
                <div
                  class="ps-3"
                  v-if="
                    chk_include_open_event_cd(
                      // lc_event.license_event_cd,
                      lc_event.id,
                      license_class
                    )
                  "
                >
                  <!-- 個別ライセンスのループ -->
                  <div
                    v-for="license in license_cd_filter(
                      lc_event.id,
                      license_class
                    )"
                    :key="license"
                    class="d-block p-0 me-1 mb-1"
                  >
                    <!-- ライセンス選択ラベル -->
                    <label
                      :for="'license_' + license.id"
                      :class="
                        'py-1 px-2 rounded-1 text-white d-block ' +
                        attach_license_class_label(license.id)
                      "
                      @click="
                        attach_license(
                          // license.license_cd,
                          license.id,
                          lc_event.id,
                          license_class
                        )
                      "
                    >
                      <!-- ライセンスチェックボックスアイコン -->
                      <i
                        :class="
                          attach_license_class_checkbox(license.id) + ' me-1'
                        "
                      ></i>
                      {{ license.short_label }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col mb-2">
            <label for="MFJ_AREA" class="mb-1 badge bg-secondary">地区</label>
            <div
              class="w-100 border py-1 px-2"
              style="height: 300px; overflow-y: scroll"
            >
              <div
                v-for="region in region_cd_list"
                :key="region"
                class="mb-2 pb-1 container"
              >
                <div
                  :class="
                    'row py-1 px-2 rounded-1 mb-2 border ' +
                    attach_region_class_label(region.key)
                  "
                >
                  <div class="col-9" @click="attach_region(region.key)">
                    <i :class="attach_region_class_checkbox(region.key)"></i
                    >&nbsp;
                    {{ region.label }}
                  </div>
                  <div
                    class="col-3 text-end"
                    @click="attach_open_region(region.key)"
                  >
                    <i :class="attach_region_class_caret(region.key)"></i>
                  </div>
                </div>
                <div class="ps-3" v-if="chk_include_open_region_cd(region.key)">
                  <div
                    v-for="pref in pref_filter(region.key)"
                    :key="pref"
                    class="d-inline-block p-0 me-1 mb-1"
                  >
                    <label
                      :for="'pref_' + pref.key"
                      :class="
                        'py-1 px-2 rounded-1 text-white ' +
                        attach_pref_class_label(pref.key)
                      "
                      @click="attach_pref(pref.key)"
                    >
                      <i :class="attach_pref_class_checkbox(pref.key)"></i>
                      {{ pref.label }}</label
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2 d-none">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">保険期間範囲</p>
          </div>
          <div class="col-8 mb-2">
            <div class="input-group">
              <input
                type="date"
                v-model="sprm.application_date_higher"
                class="form-control"
                placeholder=""
              />
              <span class="input-group-text">〜</span>
              <input
                type="date"
                v-model="sprm.application_date_lower"
                class="form-control"
                placeholder="会員名"
              />
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">所属</p>
          </div>
          <div class="col-2 mb-2">
            <bs-select
              :options="affiliation_type_list"
              v-model="sprm.affiliation"
              :null-option="true"
              id="Affiniation"
              :classParam="'form-select'"
            ></bs-select>
          </div>
          <div class="col-4 mb-2"></div>
          <div class="col-2 mb-2">
            <p class="text-center py-1 fs-5">表示件数</p>
          </div>
          <div class="col-2 mb-2">
            <bs-select
              :options="get_page_num_list"
              v-model="page_limit"
              :null-option="true"
              id="MainClinicId"
              :classParam="'form-select'"
            ></bs-select>
          </div>
        </div>

        <div class="row">
          <div class="col text-center"></div>
          <div class="col text-center">
            <bs-button :btnClass="'btn-primary'" @to_click_event="search_member"
              >条件で検索</bs-button
            >
          </div>
          <div class="col text-end">
            <bs-button
              :btnClass="'btn-light btn-outline-secondary'"
              @to_click_event="clear"
              >検索条件クリア</bs-button
            >
          </div>
        </div>
      </div>
    </div>
    <div
      class="w100"
      v-if="
        typeof member_list === 'object' && Object.keys(member_list).length > 0
      "
    >
      <table class="table mb-4">
        <thead>
          <tr>
            <th>
              <label
                @click="sort_order('mfj_member_data.license_no', 'ASC')"
                class="btn_order"
                ><i class="bi bi-caret-up-fill"></i
              ></label>
              No
              <label
                @click="sort_order('mfj_member_data.license_no', 'DESC')"
                class="btn_order"
                ><i class="bi bi-caret-down-fill"></i
              ></label>
            </th>
            <th>
              <label
                @click="sort_order('mfj_member_data.name_1', 'ASC')"
                class="btn_order"
                ><i class="bi bi-caret-up-fill"></i
              ></label>
              会員名(カナ)
              <label
                @click="sort_order('mfj_member_data.name_1', 'DESC')"
                class="btn_order"
                ><i class="bi bi-caret-down-fill"></i
              ></label>
            </th>
            <th>
              <label
                @click="sort_order('mfj_member_profile.pref_cd', 'ASC')"
                class="btn_order"
                ><i class="bi bi-caret-up-fill"></i
              ></label>
              <span style="font-size: 0.7rem">都道府県</span>
              <label
                @click="sort_order('mfj_member_profile.pref_cd', 'DESC')"
                class="btn_order"
                ><i class="bi bi-caret-down-fill"></i
              ></label>
            </th>
            <th>
              <label
                @click="sort_order('mfj_member_data.birth_date', 'ASC')"
                class="btn_order"
                ><i class="bi bi-caret-up-fill"></i
              ></label>
              生年月日
              <label
                @click="sort_order('mfj_member_data.birth_date', 'DESC')"
                class="btn_order"
                ><i class="bi bi-caret-down-fill"></i
              ></label>
            </th>
            <th>
              <label
                @click="sort_order('mfj_member_data.last_sports_year', 'ASC')"
                class="btn_order"
                ><i class="bi bi-caret-up-fill"></i
              ></label>
              <span style="font-size: 0.7rem">更新年</span>
              <label
                @click="sort_order('mfj_member_data.last_sports_year', 'DESC')"
                class="btn_order"
                ><i class="bi bi-caret-down-fill"></i
              ></label>
            </th>
            <th>競技/PIT</th>
            <th>競技役員</th>
            <th>講師</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="list in member_list" :key="list.id">
            <td>{{ list.license_no }}</td>
            <td>{{ list.name_label }}({{ list.yomi_label }})</td>
            <td>{{ list.pref_label }}</td>
            <td>{{ list.birth_date_label }}</td>
            <td>{{ list.last_sports_year }}</td>
            <td>
              <div class="d-block w-100">
                <div
                  style="font-size: 0.8rem"
                  class="d-block me-1"
                  v-for="license in get_license_filter_class(
                    list.member_license,
                    1
                  )"
                  :key="license.id"
                >
                  {{ license.short_label }}
                </div>
                <div
                  style="font-size: 0.8rem"
                  class="d-block me-1"
                  v-for="license in get_license_filter_class(
                    list.member_license,
                    4
                  )"
                  :key="license.id"
                >
                  {{ license.short_label }}
                </div>
              </div>
            </td>
            <td>
              <div
                class="d-block"
                v-for="license in get_license_filter_class(
                  list.member_license,
                  2
                )"
                :key="license.id"
              >
                {{ license.short_label }}
              </div>
            </td>
            <td>
              <div
                class="d-block"
                v-for="license in get_license_filter_class(
                  list.member_license,
                  3
                )"
                :key="license.id"
              >
                {{ license.short_label }}
              </div>
            </td>
            <td>
              <bs-button
                :btnClass="'btn-light btn-sm btn-outline-secondary'"
                @to_click_event="handleClick(list.id)"
                >照会</bs-button
              >
            </td>
          </tr>
        </tbody>
      </table>
      <div class="row">
        <div class="col-8">
          <bs-page-nav
            :pager_key="'member'"
            @to_click_event="pageAction"
          ></bs-page-nav>
        </div>
        <div class="col-2 text-end">
          <bs-select
            :options="[
              {
                key: '1',
                label: '基本情報'
              },
              {
                key: '2',
                label: 'ライセンス情報'
              }
            ]"
            v-model="sprm.csv_type"
            :null-option="true"
            id="csv_type"
            :classParam="'form-select'"
          ></bs-select>
        </div>
        <div class="col-2 text-end">
          <bs-button :btnClass="'btn-warning'" @to_click_event="download"
            >CSVダウンロード</bs-button
          >
        </div>
      </div>
    </div>
    <div v-else>
      <p class="alert alert-warning">NO DATA</p>
    </div>
  </div>
</template>
<style>
.btn_order {
  text-decoration: none;
  cursor: pointer;
}
</style>

<script>
import { mapState } from 'vuex'
import BsPageTitle from '../../molecules/BsPageTitle.vue'
import BsMsgAlert from '../../atoms/BsMsgAlert.vue'
// import '../../assets/bootstrap/css/sc.css';
import Common from '../../../common/common'
import BsButton from '../../atoms/BsButton.vue'
import BsSelect from '../../atoms/BsSelect.vue'
import BsPageNav from '../../molecules/BsPageNav.vue'
import config from '../../../const'
import moment from 'moment'

export default {
  name: 'MemberListView',
  data: function () {
    return {
      alertMessage: '',
      alertClass: 'alert-info',
      fromParentTitle: '会員データ一覧',
      fromParentBtn: 'データ登録',
      member_obj: [],
      search_license_no: '',
      search_member_obj: {},
      sprm: {
        csv_type: '',
        license_no: '',
        like_name: '',
        like_name_1: '',
        like_name_2: '',
        like_yomi_1: '',
        like_yomi_2: '',
        last_sports_year: '',
        last_sports_year_higher: '',
        last_sports_year_lower: '',
        search_words: '',
        pref_cd: [],
        birth_date: '',
        birth_date_year: '',
        birth_date_month: '',
        birth_date_day: '',
        region_cd: [],
        license_cd: [],
        license_event_cd: [],
        event_cd: [],
        affiliation: '',
        sp_license_cd: '',
        sp_license_year: ''
      },
      attach_license_event_cd: [],
      open_region_cd: [],
      open_event_cd: [],
      page: 0,
      page_limit: 10,
      page_sort: 'ASC',
      page_order: 'mfj_member_data.license_no',
      target_name: '',
      region_obj: [],
      pref_obj: [],
      license_cd_obj: [],
      license_event_cd_obj: [],
      event_cd_obj: [],
      license_type_obj: [],
      affiliation_type_obj: [],
      term_year_obj: [],
      isLoading: false
    }
  },
  components: {
    BsPageTitle,
    BsButton,
    BsMsgAlert,
    BsSelect,
    BsPageNav
  },
  computed: {
    chk_watch_last_sports_year_higher: function () {
      return this.sprm.last_sports_year_higher
    },
    chk_watch_last_sports_year_lower: function () {
      return this.sprm.last_sports_year_lower
    },
    chk_watch_last_sports_year: function () {
      return this.sprm.last_sports_year
    },
    get_term_year: function () {
      return typeof this.term_year_obj === 'object' &&
        typeof this.term_year_obj[0] === 'object' &&
        this.term_year_obj[0]['label']
        ? parseInt(this.term_year_obj[0]['label'])
        : parseInt(Common.getNowYear())
    },
    ...mapState({}),
    get_wareki: function () {
      const regex1 = /^[0-9]{4}[/-](0[1-9]|1[0-2])[/-](0[1-9]|[12][0-9]|3[01])/

      return function (birth_date) {
        if (regex1.test(birth_date)) {
          console.log('get_wareki', regex1.test(birth_date), birth_date)
          return new Date(birth_date).toLocaleDateString(
            'ja-JP-u-ca-japanese',
            {
              dateStyle: 'long'
            }
          )
        }
        return birth_date
      }
    },
    affiliation_type_list: function () {
      return this.affiliation_type_obj
    },
    event_list: function () {
      return config.EVENT_CD_LIST
    },
    license_list: function () {
      return config.LICENSE_CD_LIST
    },
    license_filter: function () {
      const license_list = this.license_list
      return function (event_key) {
        return license_list.filter(lc => {
          if (
            typeof lc.groups === 'object' &&
            lc.groups.find(group => group == event_key)
          ) {
            return true
          }
          return false
        })
      }
    },
    get_license_filter_class: function () {
      const last_sports_year = this.sprm.last_sports_year
      const last_sports_year_higher = this.sprm.last_sports_year_higher
      const last_sports_year_lower = this.sprm.last_sports_year_lower
      const term_year = this.get_term_year
      return function (member_license, license_class) {
        // member_licenseがfalseまたは配列でない場合は空配列を返す
        if (!member_license || !Array.isArray(member_license)) {
          return []
        }

        // license_classが一致するものをフィルタリング
        return member_license.filter(license => {
          return (
            license.license_class === String(license_class) &&
            license.stat === '1' &&
            license.short_label &&
            ((last_sports_year != '' &&
              last_sports_year == license.license_year) ||
              (last_sports_year_higher != '' &&
                last_sports_year_higher <= license.license_year) ||
              (last_sports_year_lower != '' &&
                last_sports_year_lower >= license.license_year) ||
              (last_sports_year == '' && term_year == license.license_year))
          )
        })
      }
    },

    license_event_cd_filter: function () {
      const license_event_cd_obj = this.license_event_cd_obj
      const license_cd_list = this.license_cd_list
      return function (license_class) {
        // console.log('開始 - license_class:', license_class)

        // 競技の場合（license_class = 1）
        if (license_class === 1) {
          // console.log('license_event_cd_obj ', license_event_cd_obj)
          if (!license_event_cd_obj || !Array.isArray(license_event_cd_obj)) {
            // console.error(
            //   'license_event_cd_objが未定義または配列ではありません-'
            // )
            return []
          }

          return typeof license_event_cd_obj === 'object'
            ? license_event_cd_obj
            : []
                .filter(list => {
                  if (list) return true
                  return true // 競技は全て表示
                })
                .map(list => ({
                  ...list,
                  key: list.id, // list.license_event_cd から変更
                  label: list.label || '名称なし'
                }))
                .sort((a, b) => parseInt(a.sort || 0) - parseInt(b.sort || 0))
        }
        // PITの場合
        else if (license_class === 4) {
          if (!license_cd_list || !Array.isArray(license_cd_list)) {
            // console.error('license_cd_listが未定義または配列ではありません--')
            return []
          }
          return license_cd_list
            .filter(list => {
              // console.log('一般フィルタリング対象:', list)
              return String(list.license_class) === String(license_class)
            })
            .map(list => ({
              ...list,
              key: list.id, // list.license_cd から変更
              label: list.label || list.short_label || '名称なし',
              license_event_cd: list.id // list.license_event_cd から変更
            }))
            .sort((a, b) => parseInt(a.sort || 0) - parseInt(b.sort || 0))
        }
        // 競技以外の場合（役員/講師）
        else {
          if (!license_cd_list || !Array.isArray(license_cd_list)) {
            // console.error('license_cd_listが未定義または配列ではありません-')
            return []
          }

          return typeof license_event_cd_obj === 'object'
            ? license_event_cd_obj
            : []
                .filter(list => {
                  if (
                    license_cd_list.find(
                      lc =>
                        lc.license_event_cd == list.id &&
                        lc.license_class == license_class
                    )
                  ) {
                    return true
                  }
                  return false
                })
                .map(list => ({
                  ...list,
                  key: list.id, // list.license_event_cd から変更
                  label: list.label || '名称なし'
                }))
                .sort((a, b) => parseInt(a.sort || 0) - parseInt(b.sort || 0))
        }
      }
    },

    // イベントコードリストの生成
    event_cd_list: function () {
      const lists = [...this.event_cd_obj]
      return lists
        .map(list => {
          list.key = list.event_cd
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },

    // ライセンスコードリストの生成と並び替え
    license_cd_list: function () {
      const lists = [...this.license_cd_obj]
      return (
        lists
          .map(list => {
            list.key = list.license_cd
            return list
          })
          // ライセンスカテゴリとソート順による複数条件での並び替え
          .sort((a, b) => {
            if (parseInt(a.license_category) < parseInt(b.license_category)) {
              return -1
            }
            if (parseInt(a.license_category) > parseInt(b.license_category)) {
              return 1
            }
            if (parseInt(a.sort) < parseInt(b.sort)) {
              return -1
            }
            if (parseInt(a.sort) > parseInt(b.sort)) {
              return 1
            }
            return 0
          })
      )
    },

    // ライセンスコードのフィルタリング
    license_cd_filter: function () {
      const license_cd_list = this.license_cd_list
      // const license_type_list = this.license_type_list
      return function (license_event_id, license_class) {
        return license_cd_list.filter(license => {
          // 指定されたイベントコードとライセンスクラスに一致するものだけを抽出
          if (
            typeof license === 'object' &&
            parseInt(license_event_id) > 0 &&
            license.license_event_cd == license_event_id &&
            // typeof license.license_cd === 'string' &&
            // typeof license_type_list === 'object' &&
            // license_type_list.find(
            //   type =>
            //     type.license_cd == license.license_cd &&
            //     type.event_cd == license_event_id
            // ) &&
            license_class != false &&
            license_class != undefined &&
            license.license_class == license_class
          ) {
            return true
          }
          return false
        })
      }
    },

    // ライセンスタイプリストの生成
    license_type_list: function () {
      const lists = [...this.license_type_obj]
      return lists
        .map(list => {
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },

    // region_list: function(){
    //     return config.AREA_CD_LIST;
    // },
    // pref_list: function(){
    //     return config.PREF_CD_LIST;
    // },
    pref_cd_list: function () {
      const lists = [...this.pref_obj]
      return lists
        .map(list => {
          list.key = list.id
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    region_cd_list: function () {
      const lists = [...this.region_obj]
      return lists
        .map(list => {
          list.key = list.region_cd
          return list
        })
        .sort((a, b) => {
          if (parseInt(a.sort) < parseInt(b.sort)) {
            return -1
          } else {
            return 1
          }
        })
    },
    pref_filter: function () {
      const pref_cd_list = this.pref_cd_list
      return function (region_key) {
        return pref_cd_list.filter(pref => pref.region_cd == region_key)
      }
    },
    year_list: function () {
      let now = parseInt(Common.getNowYear()) + 1
      let limit = 2018
      const tmps = []
      for (let i = now; i > limit; i--) {
        tmps.push({
          key: i,
          label: i + '年度'
        })
      }
      return tmps
    },
    birth_date_year_list: function () {
      let now = 1920
      let limit = parseInt(Common.getNowYear()) + 1
      const tmps = []
      for (let i = now; i < 1970; i++) {
        tmps.push({
          key: i,
          label: i
        })
      }
      tmps.push({
        key: '',
        label: '選択して下さい'
      })
      for (let i = 1970; i < limit; i++) {
        tmps.push({
          key: i,
          label: i
        })
      }
      return tmps
    },
    birth_date_month_list: function () {
      const tmps = []
      for (let i = 1; i <= 12; i++) {
        tmps.push({
          key: i,
          label: i
        })
      }
      return tmps
    },
    birth_date_day_list: function () {
      // const moment_date = moment();
      const moment_func = moment
      return function (year, month) {
        let max = 31
        if (year != '' && month != '') {
          const moment = moment_func([year, parseInt(month) - 1, 1])
          max = moment.daysInMonth()
        }
        const tmps = []
        for (let i = 1; i <= max; i++) {
          tmps.push({
            key: i,
            label: i
          })
        }
        return tmps
      }
    },
    member_list: function () {
      const lists = [...this.member_obj]
      lists.map(list => {
        // list['name_label'] = (list.name_1)? list.name_1: '';
        // list['name_label'] += (list.name_2)? list.name_2: '';
        // list['name_label'] += (list.name_3)? list.name_3: '';

        // list['main_clinic_label'] = this.get_clinic_label(list.main_clinic_id);
        return list
      })
      return lists
    },
    get_clinic_data: function () {
      const clinic_list = this.clinic_list
      return function (clinic_id) {
        return clinic_list.find(clinic => {
          return clinic.id == clinic_id
        })
      }
    },
    get_clinic_label: function () {
      const get_clinic_data = this.get_clinic_data
      return function (clinic_id) {
        return typeof get_clinic_data(clinic_id) === 'object'
          ? get_clinic_data(clinic_id).label
          : '-'
      }
    },
    // event
    chk_include_event_cd: function () {
      const attach_license_event_cd = this.attach_license_event_cd
      return function (license_event_id, license_class) {
        // console.log(license_class);
        if (
          attach_license_event_cd.find(
            lc =>
              lc.license_event_id == license_event_id &&
              parseInt(lc.license_class) == parseInt(license_class)
          )
        ) {
          return true
        }
        return false
      }
    },
    attach_event_class_label: function () {
      const chk_comp = this.chk_include_event_cd
      return function (license_event_id, license_class) {
        if (chk_comp(license_event_id, license_class)) {
          return 'text-white bg-primary border border-primary'
        }
        return 'text-dark bg-light border border-secondary'
      }
    },
    attach_event_class_checkbox: function () {
      const chk_comp = this.chk_include_event_cd
      return function (license_event_id, license_class) {
        if (chk_comp(license_event_id, license_class)) {
          return 'bi-check-square'
        }
        return 'bi-square'
      }
    },
    chk_include_open_event_cd: function () {
      const open_event_cd = this.open_event_cd
      return function (license_event_id, license_class) {
        if (
          open_event_cd.find(
            cd =>
              cd.license_event_id == license_event_id &&
              cd.license_class == license_class
          )
          // open_event_cd.indexOf(event_cd) > -1
        ) {
          return true
        }
        return false
      }
    },
    attach_event_class_caret: function () {
      const chk_comp = this.chk_include_open_event_cd
      return function (event_cd, license_class) {
        if (chk_comp(event_cd, license_class)) {
          return 'bi-caret-up-fill'
        }
        return 'bi-caret-down-fill'
      }
    },

    // license
    chk_include_license_cd: function () {
      const sprm_license = this.sprm.sp_license_cd
      return function (license_id) {
        if (sprm_license.indexOf(license_id) > -1) {
          return true
        }
        return false
      }
    },
    attach_license_class_label: function () {
      const chk_comp = this.chk_include_license_cd
      return function (license_id) {
        if (chk_comp(license_id)) {
          return 'bg-primary'
        }
        return 'bg-secondary'
      }
    },
    attach_license_class_checkbox: function () {
      const chk_comp = this.chk_include_license_cd
      return function (license_id) {
        if (chk_comp(license_id)) {
          return 'bi-check-square'
        }
        return 'bi-square'
      }
    },

    // region
    chk_include_region_cd: function () {
      const sprm_region = this.sprm.region_cd
      return function (region_cd) {
        if (sprm_region.indexOf(region_cd) > -1) {
          return true
        }
        return false
      }
    },
    attach_region_class_label: function () {
      const chk_comp = this.chk_include_region_cd
      return function (region_cd) {
        if (chk_comp(region_cd)) {
          return 'text-white bg-primary border border-primary'
        }
        return 'text-dark bg-light border border-secondary'
      }
    },
    attach_region_class_checkbox: function () {
      const chk_comp = this.chk_include_region_cd
      return function (region_cd) {
        if (chk_comp(region_cd)) {
          return 'bi-check-square'
        }
        return 'bi-square'
      }
    },
    chk_include_open_region_cd: function () {
      const open_region_cd = this.open_region_cd
      return function (region_cd) {
        if (open_region_cd.indexOf(region_cd) > -1) {
          return true
        }
        return false
      }
    },
    attach_region_class_caret: function () {
      const chk_comp = this.chk_include_open_region_cd
      return function (region_cd) {
        if (chk_comp(region_cd)) {
          return 'bi-caret-up-fill'
        }
        return 'bi-caret-down-fill'
      }
    },

    // pref
    chk_include_pref_cd: function () {
      const sprm_pref = this.sprm.pref_cd
      return function (pref_cd) {
        if (sprm_pref.indexOf(pref_cd) > -1) {
          return true
        }
        return false
      }
    },
    attach_pref_class_label: function () {
      const chk_comp = this.chk_include_pref_cd
      return function (pref_cd) {
        if (chk_comp(pref_cd)) {
          return 'bg-primary'
        }
        return 'bg-secondary'
      }
    },
    attach_pref_class_checkbox: function () {
      const chk_comp = this.chk_include_pref_cd
      return function (pref_cd) {
        if (chk_comp(pref_cd)) {
          return 'bi-check-square'
        }
        return 'bi-square'
      }
    }
  },

  async created() {
    await this.loadTermYear()
    await this.loadEventCdList()
    await this.loadLicenseEventCdList()
    await this.loadLicenseCdList()
    await this.loadLicenseTypeList()
    await this.loadRegionList()
    await this.loadPrefList()
    await this.loadAffiliationTypeList()
    await this.loadSearchParam()
    await this.loadMemberList(false)
  },
  mounted: function () {
    // console.log(this.$route.path);
    // console.log('strage', this.$store.state.article, this.lists);
    // this.fromParentTitle = '商品詳細';
    this.alertMessage = '会員データ一覧です。'
  },

  methods: {
    // event
    attach_open_event(license_event_id, license_class) {
      const tmps =
        typeof this.open_event_cd === 'object' ? [...this.open_event_cd] : []
      if (this.chk_include_open_event_cd(license_event_id, license_class)) {
        const tmps_index = tmps.findIndex(
          tmp =>
            tmp.license_event_id == license_event_id &&
            tmp.license_class == license_class
        )
        tmps.splice(tmps_index, 1)
      } else {
        tmps.push({
          license_event_id: license_event_id,
          license_class: license_class
        })
      }

      // if(
      //     tmps.indexOf(license_event_cd) > -1
      // ){
      //     tmps.splice(tmps.indexOf(license_event_cd), 1);
      // }
      // else{
      //     tmps.push(license_event_cd);
      // }

      this.open_event_cd = tmps
    },
    attach_event(license_event_id, license_class) {
      console.log(
        'attach_event',
        license_event_id,
        license_class,
        this.chk_include_event_cd(license_event_id, license_class)
      )
      if (
        this.chk_include_open_event_cd(license_event_id, license_class) ===
        false
      ) {
        this.attach_open_event(license_event_id, license_class)
      }
      const tmps =
        typeof this.attach_license_event_cd === 'object'
          ? [...this.attach_license_event_cd]
          : []

      // ON→OFF
      if (
        this.chk_include_event_cd(license_event_id, license_class)
        // tmps.indexOf(license_event_cd) > -1
      ) {
        const lc_cd = [...this.sprm.sp_license_cd]
        this.sprm.sp_license_cd = lc_cd.filter(lc => {
          if (
            typeof this.license_cd_filter(license_event_id, license_class) ===
              'object' &&
            this.license_cd_filter(license_event_id, license_class).find(
              chk => chk.license_cd == lc
            )
          ) {
            return false
          }
          return true
        })
        this.attach_license_event_cd = tmps.filter(tmp => {
          if (
            tmp.license_event_id == license_event_id &&
            parseInt(tmp.license_class) == parseInt(license_class)
          ) {
            return false
          }
          return true
        })
      }
      // OFF→ON
      else {
        tmps.push({
          license_class: license_class,
          license_event_id: license_event_id
        })
        this.attach_license_event_cd = tmps

        if (
          typeof this.license_cd_filter(license_event_id, license_class) ===
          'object'
        ) {
          this.license_cd_filter(license_event_id, license_class).forEach(
            license => {
              if (
                this.chk_include_event_cd(license.event_cd, license_class) ===
                  false &&
                this.sprm.sp_license_cd.includes(license.license_cd) === false
              ) {
                this.attach_license(
                  // license.license_cd,
                  license.id,
                  license_event_id,
                  license_class
                )
              }
            }
          )
        }
      }
      this.sprm.license_event_cd = tmps
      this.$forceUpdate()
    },

    // license
    attach_license(license_id, license_event_id, license_class) {
      console.log('attach_license license_id', license_id, license_class)
      const tmps =
        typeof this.sprm.sp_license_cd === 'object'
          ? [...this.sprm.sp_license_cd]
          : []
      if (tmps.indexOf(license_id) > -1) {
        console.log('attach_license nashi')
        tmps.splice(tmps.indexOf(license_id), 1)
        if (
          this.chk_include_event_cd(license_event_id, license_class) === true
        ) {
          const event_tmp = [...this.attach_license_event_cd]
          const lc_index = event_tmp.findIndex(
            lc =>
              lc.license_event_id == license_event_id &&
              lc.license_class == license_class
          )
          event_tmp.splice(lc_index, 1)
          this.attach_license_event_cd = event_tmp
        }
      } else {
        tmps.push(license_id)
        console.log(
          'attach_license ari',
          tmps.length,
          this.license_cd_filter(license_event_id, license_class).length
        )

        if (
          (
            tmps.filter(lc => {
              if (
                this.license_cd_filter(license_event_id, license_class).find(
                  lcd => lcd.license_cd == lc
                )
              ) {
                return true
              }
              return false
            }) || []
          ).length ==
          this.license_cd_filter(license_event_id, license_class).length
        ) {
          const event_tmp = [...this.attach_license_event_cd]
          event_tmp.push({
            license_event_id: license_event_id,
            license_class: license_class
          })
          this.attach_license_event_cd = event_tmp
        }
        // if(
        //     tmps.filter(
        //         (license) => {
        //             if(
        //                 this.license_type_list.find(
        //                     (tp) => (tp.license_cd == license && tp.event_cd == license_event_cd && tp.license_class == license_class)
        //                 )
        //             ){
        //                 return true;
        //             }
        //             return false
        //         }).length == this.license_cd_filter(license_event_cd, license_class).length
        //     && this.chk_include_event_cd(license_event_cd, license_class) === false
        // ){
        //     const event_tmp = [...this.attach_license_event_cd];
        //     event_tmp.push({
        //         license_event_cd: license_event_cd,
        //         license_class: license_class
        //     });
        //     this.attach_license_event_cd = event_tmp;
        // }
      }
      this.sprm.sp_license_cd = tmps
      this.$forceUpdate()
    },

    // region
    attach_open_region(region_cd) {
      const tmps =
        typeof this.open_region_cd === 'object' ? [...this.open_region_cd] : []
      if (tmps.indexOf(region_cd) > -1) {
        tmps.splice(tmps.indexOf(region_cd), 1)
      } else {
        tmps.push(region_cd)
      }
      this.open_region_cd = tmps
    },
    attach_region(region_cd) {
      if (this.chk_include_open_region_cd(region_cd) === false) {
        this.attach_open_region(region_cd)
      }
      const tmps =
        typeof this.sprm.region_cd === 'object' ? [...this.sprm.region_cd] : []
      if (tmps.indexOf(region_cd) > -1) {
        tmps.splice(tmps.indexOf(region_cd), 1)
        this.sprm.pref_cd = []
      } else {
        tmps.push(region_cd)
        if (typeof this.pref_filter(region_cd) === 'object') {
          this.pref_filter(region_cd).forEach(pref => {
            if (this.chk_include_pref_cd(pref.key) === false) {
              this.attach_pref(pref.key)
            }
          })
        }
      }
      this.sprm.region_cd = tmps
    },
    // pref
    attach_pref(pref_cd) {
      const tmps =
        typeof this.sprm.pref_cd === 'object' ? [...this.sprm.pref_cd] : []
      const tmp_grp = this.pref_cd_list.find(
        pref => pref.key == pref_cd
      ).region_cd
      if (tmps.indexOf(pref_cd) > -1) {
        tmps.splice(tmps.indexOf(pref_cd), 1)
        if (this.chk_include_region_cd(tmp_grp) === true) {
          const region_tmp = [...this.sprm.region_cd]
          region_tmp.splice(region_tmp.indexOf(tmp_grp), 1)
          this.sprm.region_cd = region_tmp
        }
      } else {
        tmps.push(pref_cd)
        if (
          tmps.filter(pref => {
            const get_tp = this.pref_cd_list.find(tp => tp.key == pref)
            if (get_tp.region_cd == tmp_grp) {
              return true
            }
            return false
          }).length == this.pref_filter(tmp_grp).length &&
          this.chk_include_region_cd(tmp_grp) === false
        ) {
          const region_tmp = [...this.sprm.region_cd]
          region_tmp.push(tmp_grp)
          this.sprm.region_cd = region_tmp
        }
      }
      this.sprm.pref_cd = tmps
    },

    go_consulting(target) {
      this.$router.push({
        // name: 'process_detail',
        path: '/consulting/add',
        query: {
          m_id: target
        }
      })
    },
    delData(target) {
      if (confirm('削除しますか？')) {
        const data = this.cate_obj.find(cate => {
          return cate.id == target
        })
        // console.log('ret ticket data' ,ticket);
        data['stat'] = 9
        return this.$store
          .dispatch('updateBasic', { data: data, target: 'member' })
          .then(() => {
            this.alertMessage = '削除しました'
            this.alertClass = 'alert-success'
          })
          .catch(err => {
            // Promise.reject(err)
            console.log(err)
            this.alertMessage = '削除できませんでした'
            this.alertClass = 'alert-danger'
          })
          .finally(() => {
            this.loadCateList()
          })
      }
    },
    async loadSearchParam() {
      const params = { ...this.$store.getters.getSearchParam('member') }
      if (params) {
        Object.keys(params).forEach(key => {
          if (this.is_json(params[key])) {
            params[key] = JSON.parse(params[key])
          }
          this.sprm[key] = params[key]
        })
      }
    },

    async download() {
      if (!this.sprm.csv_type) {
        this.alertMessage = 'ダウンロードするCSVの種類を選択してください。'
        this.alertClass = 'alert-warning'
        return
      }
      await this.loadMemberList('csv')
    },
    async search_member_license_no() {
      console.log(
        'search_license_no',
        this.search_license_no,
        typeof this.search_license_no
      )
      if (this.search_license_no.length == 6) {
        await this.loadMemberList(this.search_license_no)
      }
    },
    async sort_order(order, sort) {
      this.page_order = order ? order : 'id'
      this.page_sort = sort ? sort : 'ASC'

      await this.loadMemberList(false)
    },
    async search_member() {
      this.isLoading = true
      try {
        await new Promise(resolve => setTimeout(resolve, 500))
        this.page = 0
        await this.loadMemberList(false)
      } finally {
        this.isLoading = false
      }
    },
    async loadMemberList(flg) {
      const params = {}
      params['stat'] = [1]

      let post_url = config.BASE_API_URL
      if (flg == 'csv') {
        post_url += '/member/output_csv'
        if (typeof this.sprm === 'object') {
          Object.keys(this.sprm).forEach(sprm_key_param => {
            const sprm_key =
              sprm_key_param == 'license_cd'
                ? 'sp_' + sprm_key_param
                : sprm_key_param
            if (this.sprm[sprm_key] != '') {
              params[sprm_key] = this.sprm[sprm_key_param]
            }
          })
          // Object.keys(this.sprm).forEach(sprm_key => {
          //   if (this.sprm[sprm_key] != '') {
          //     params[sprm_key] = this.sprm[sprm_key]
          //   }
          // })
        }
        // CSVタイプを必ず含める
        params['csv_type'] = this.sprm.csv_type
        // params['pagegroup'] = 'mfj_member_data.id'
        params['pagelimit'] = false
        params['p'] = 0
      } else if (flg !== false) {
        // post_url += '/member/lists'
        post_url += '/member/number_search'
        params['license_no'] = flg
        // params['pagegroup'] = 'mfj_member_data.id'
      } else {
        post_url += '/member/lists'
        if (typeof this.sprm === 'object') {
          Object.keys(this.sprm).forEach(sprm_key_param => {
            const sprm_key =
              sprm_key_param == 'license_cd'
                ? 'sp_' + sprm_key_param
                : sprm_key_param
            if (this.sprm[sprm_key] != '') {
              params[sprm_key] = this.sprm[sprm_key_param]
            }
          })
        }
        params['search_mode'] = 'list'
        params['pagelimit'] = this.page_limit
        if (this.page >= 0) params['p'] = this.page
        // params['pagegroup'] = 'mfj_member_data.id'
        params['pageorder'] = this.page_order
        params['pagesort'] = this.page_sort
        this.$store.dispatch('setSearchParam', {
          data: params,
          target: 'member'
        })
      }
      console.log('loadMemberList flg', flg)
      console.log('loadMemberList sprm', this.sprm)
      console.log('loadMemberList params', params)

      await this.basicPosts_S(post_url, params)
        .then(async response => {
          if (flg == 'csv') {
            console.log('loadMemberList download response', response)
            window.open(
              config.BASE_API_URL +
                '/member/download?file=' +
                response.data.body,
              '_blank'
            )
          } else if (flg !== false) {
            console.log('loadMemberList response', response)
            const tmp_obj =
              response.data && response.data.body && response.data.body[0]
                ? response.data.body[0]
                : {}
            let name_label = ''
            console.log('loadMemberList response tmp_obj', tmp_obj)
            if (typeof tmp_obj.name_1 === 'string') name_label += tmp_obj.name_1
            if (typeof tmp_obj.name_2 === 'string') name_label += tmp_obj.name_2
            if (typeof tmp_obj.name_3 === 'string') name_label += tmp_obj.name_3
            tmp_obj.name_label = name_label
            console.log('loadMemberList response tmp_obj', tmp_obj)
            this.search_member_obj = tmp_obj
          } else {
            console.log('loadMemberList response', response)
            this.member_obj =
              response.data && response.data.body ? response.data.body : []
            this.$store.dispatch('setSearchParam', {
              data: params,
              target: 'member'
            })
            const setPageData = {}
            setPageData.data =
              response.data && response.data.pager ? response.data.pager : {}
            setPageData.target = 'member'
            this.$store.dispatch('setPager', setPageData)
          }
        })
        .catch(async err => {
          console.log(err)
          if (!flg) this.member_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    clear() {
      const params = { ...this.sprm }
      if (typeof params === 'object') {
        Object.keys(params).forEach(sprm_key => {
          params[sprm_key] = ''
        })
      }
      this.sprm = params
      this.attach_license_event_cd = []
      this.$store.dispatch('setSearchParam', {
        data: params,
        target: 'member'
      })
    },
    handleClick(target) {
      this.$router.push({ path: '/member/' + target + '/' })
    },
    async pageAction(page) {
      this.page = page
      await this.loadMemberList(false)
    },
    async loadPrefList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/area_pref/lists', params)
        .then(async response => {
          console.log('loadPrefList response', response)
          this.pref_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.pref_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadRegionList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/area_region/lists',
        params
      )
        .then(async response => {
          console.log('loadRegionList response', response)
          this.region_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.region_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/license_cd/lists', params)
        .then(async response => {
          console.log('loadLicenseCdList response', response)
          this.license_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadTermYear() {
      const params = {}
      await this.basicPosts_S(config.BASE_API_URL + '/term_year/lists', params)
        .then(async response => {
          console.log('loadTermYear response', response)
          this.term_year_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.term_year_obj = []
        })
        .finally(async () => {
          // this.sprm.last_sports_year = this.get_term_year
          //   ? this.get_term_year
          //   : ''
          this.$forceUpdate()
        })
    },
    async loadEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(config.BASE_API_URL + '/event_cd/lists', params)
        .then(async response => {
          console.log('loadEventCdList response', response)
          this.event_cd_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseEventCdList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_event_cd/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseEventCdList response', response)
          this.license_event_cd_obj =
            response.data && response.data.body ? response.data.body : []
          console.log(
            'loadLicenseEventCdList license_event_cd_obj',
            this.license_event_cd_obj
          )
        })
        .catch(async err => {
          console.log(err)
          this.license_event_cd_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadLicenseTypeList() {
      const params = {}
      params['stat'] = [1]
      await this.basicPosts_S(
        config.BASE_API_URL + '/license_type/lists',
        params
      )
        .then(async response => {
          console.log('loadLicenseTypeList response', response)
          this.license_type_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.license_type_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadAffiliationTypeList() {
      const params = {}
      await this.basicPosts_S(
        config.BASE_API_URL + '/config/affiliation_type',
        params
      )
        .then(async response => {
          console.log('loadAffiliationTypeList response', response)
          this.affiliation_type_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.affiliation_type_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    }
  },
  watch: {
    search_license_no: function (new_data, old_data) {
      if (new_data.length >= 6) {
        console.log(old_data)
        this.search_member_license_no()
      }
    },
    chk_watch_last_sports_year_higher: function (new_data, old_data) {
      // const param = { ...this.sprm }
      this.sprm.last_sports_year = ''
      if (
        parseInt(new_data) <= parseInt(this.sprm.last_sports_year_lower) ||
        this.sprm.last_sports_year_lower == ''
      ) {
        this.sprm.last_sports_year_higher = new_data
      } else {
        this.sprm.last_sports_year_higher = old_data
      }
      console.log('watch chk_watch_last_sports_year_higher', new_data, old_data)
    },
    chk_watch_last_sports_year_lower: function (new_data, old_data) {
      this.sprm.last_sports_year = ''
      if (
        parseInt(new_data) >= parseInt(this.sprm.last_sports_year_higher) ||
        this.sprm.last_sports_year_higher == ''
      ) {
        this.sprm.last_sports_year_lower = new_data
      } else {
        this.sprm.last_sports_year_lower = old_data
      }
      console.log('watch chk_watch_last_sports_year_lower', new_data, old_data)
    },
    chk_watch_last_sports_year: function (new_data, old_data) {
      this.sprm.last_sports_year_higher = ''
      this.sprm.last_sports_year_lower = ''
      console.log('watch chk_watch_last_sports_year', new_data, old_data)
    }
  }
}
</script>
